"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attributes = void 0;
class Attributes {
    constructor(attrs) {
        this.attributes = attrs;
    }
    getAttributes() {
        return this.attributes;
    }
    static getFromMessage(m) {
        const attrs = m.getContent().get(8);
        if (Array.isArray(attrs))
            return new Attributes(attrs);
        return undefined;
    }
}
exports.Attributes = Attributes;
